import React, { createContext, useContext, useEffect, useState } from "react";
import { AccountContext } from "../AccountContext";
import API from "../../../axios/API";
import config from "../../../config";
import { AccountType } from "../constants/AccountType";
import { Link } from "react-router-dom";

const AccountCreateContext = createContext();

const AccountCreateProvider = ({ children }) => {
  const {
    fetchByAccountId,
    setCountry,
    setAccountStepper,
    accountType,
    breadCrumbName,
    setBreadCrumbName,
    setAccountType,
  } = useContext(AccountContext);
  const [show, setShow] = useState(false);
  const [fetchBrandByAccountId, setFetchBrandByAccountId] = useState(0);
  const [accountID, setAccountID] = useState(0);
  const [financeId, setFinanceId] = useState(0);
  const [configId, setConfigId] = useState(0);
  const [dspconfigId, setDspConfigId] = useState(0);
  const [editContactId, setEditContactId] = useState(0);
  const [countryItem, setCountryItem] = useState();
  const [activeStep, setActiveStep] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [cdnBaseUrl, setCdnBaseUrl] = useState("");
  const [accountViewRefresh, setAccountViewRefresh] = useState(false);
  const [primaryUserId, setPrimaryUserId] = useState(0);
  const [gstnCopyFileImage, setGstnCopyFileImage] = useState();
  const [panCopyFileImage, setPanCopyFileImage] = useState();
  const [invoiceCopyFile, setInvoiceCopyFile] = useState();
  const [popupMessage, setPopupMessage] = useState("");

  //API Data
  const [APIData, setAPIData] = useState({
    accountId: 0,
    accountName: null,
    accountType: null,
    salesManager: null,
    accountManager: null,
    companyName: null,
    companyContact: null,
    natureOfCompany: null,
    natureOfBusiness: null,
    companyEmail: null,
    status: 0,
    walletBalance: null,
    modifiedBy: null,
    users: [
      {
        userId: 0,
        userName: null,
        password: null,
        roleId: null,
        firstName: null,
        status: 0,
        whatsappNumber: null,
        accountId: 0,
        partnerId: null,
        languageId: null,
        companyFlag: null,
        statusFlag: null,
        trafficPlusFlag: 0,
        faqsFlag: 0,
        userTypeId: 0,
        modifiedTime: null,
        modifiedBy: null,
        createdBy: null,
        contacts: [
          {
            contactId: 0,
            contactName: null,
            street1: null,
            street2: null,
            city: null,
            zip: null,
            state: null,
            country: "",
            contactNo: null,
            email: null,
            linkedIn: null,
            skype: null,
          },
        ],
      },
    ],
    financeDetail: {
      finaceDetailId: 0,
      countryCheckFlag: 1,
      name: "",
      emailId: null,
      contactNo: null,
      gstNumberFlag: null,
      gstNumber: null,
      hsnSACCode: null,
      panNo: null,
      tanNo: null,
      tanNumberFlag: null,
      serviceNumberFlag: null,
      diyAuthoriseFlag: null,
      companyGOVId: null,
      taxGOVId: null,
      taxDeductionDoc: null,
      taxDeductionCheck: null,
      clientLogoUsesFlag: null,
      acceptPrivacyFlag: null,
      ipAddress: null,
      acceptHeader: null,
      userAgent: null,
      modifiedBy: null,
      tsAgreement: null,
      modifiedTime: null,
    },
    accountConfig: null,
    invoices: [],
    activeStep: 0,
    creationStatus: 0,
    modifiedTime: null,
    startbalance: 0,
  });

  //Account information Data
  const [accountInformation, setAccountInformation] = useState({
    accountName: "",
    accountType: "",
    salesManager: "",
    accountManager: "",
    companyName: "",
    natureOfCompany: "",
    natureOfBusiness: "",
    whatsappNumber: null,
    street1: "",
    street2: "",
    city: "",
    zip: "",
    state: "",
    companyContact: null,
    companyEmail: "",
    country: "",
    isFetchComplete: false,
  });

  //Financials India Initial Values
  const [financialsIndia, setFinancialsIndia] = useState({
    finaceDetailId: 0,
    name: "",
    emailId: "",
    contactNo: "",
    gstNumberFlag: "",
    tanNumberFlag: "",
    panNo: "",
    gstNumber: null,
    clientLogoUsesFlag: null,
    hsnSACCode: null,
    tanNo: null,
    gstnCopy: null,
    panCopy: null,
    isFetchComplete: false,
  });

  //Financials Non-India Initial Values
  const [financialsNonIndia, setFinancialsNonIndia] = useState({
    name: "",
    emailId: "",
    contactNo: "",
    clientLogoUsesFlag: null,
    companyGOVId: "",
    taxGOVId: "",
    taxDeductionDoc: null,
    taxDeductionCheck: null,
    isFetchComplete: false,
  });

  //Managed Services Configuration Initial Values
  const [managedServicesConfig, setManagedServicesConfig] = useState({
    agencyCommission: "0",
    discount: "0",
    enableAffiliateFlag: 0,
    viewableImpressionFlag: 0,
  });

  //DSP Configuration Initial Values
  const [DSPConfig, setDSPConfig] = useState({
    endPointURL: "",
    defaultBidFloorPrize: "",
    defaultNAds: "",
    rtbVersion: "",
    viewableImpressionFlag: 0,
  });

  //DIY Configuration Initial Values
  const [DIYConfig, setDIYConfig] = useState({
    creditLimit: "0",
    agencyCommission: "0.0",
    viewableImpressionFlag: 0,
    enableAffiliateFlag: 0,
  });

  //Access Steper - Contacts Array
  const [userContacts, setUserContacts] = useState([]);

  //Account invoices
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    async function fetchAccount() {
      const account = await API.get(
        `${config.baseUrl}/accountservice/accounts/account/${fetchByAccountId}`
      );
      const updatedAccountInformation = account.data;

      setAPIData(updatedAccountInformation);
      setBreadCrumbName(
        <span style={{ color: "#333333" }}>
          <Link
            to={`${process.env.PUBLIC_URL}/components/account/accountview/`}
            style={{ color: "#6476BC" }}
          >
            Account
          </Link>
          &nbsp;[ {updatedAccountInformation?.accountName} (
          {updatedAccountInformation?.accountId}) ]
        </span>
      );
      setAccountStepper({
        information: updatedAccountInformation.accountId > 0,
        financials:
          updatedAccountInformation.financeDetail &&
          updatedAccountInformation.financeDetail?.finaceDetailId > 0,
        configuration:
          updatedAccountInformation.accountConfig &&
          updatedAccountInformation.accountConfig?.accountConfigId > 0,
        access:
          accountType == AccountType.MANAGED
            ? updatedAccountInformation.financeDetail?.finaceDetailId > 0
            : updatedAccountInformation.accountConfig?.accountConfigId > 0,
        invoice: updatedAccountInformation.accountConfig?.accountConfigId > 0,
      });
      setCountry(updatedAccountInformation?.users[0]?.contacts[0]?.country);
      setPrimaryUserId(
        updatedAccountInformation.users?.find((user) => user.primaryFlag)?.userId
          ? updatedAccountInformation.users?.find((user) => user.primaryFlag)
              ?.userId
          : 0
      );
      setCdnBaseUrl(updatedAccountInformation.cdnBaseUrl);
      setConfigId(
        updatedAccountInformation.accountConfig
          ? updatedAccountInformation.accountConfig.accountConfigId
          : 0
      );
      setFinanceId(
        updatedAccountInformation.financeDetail
          ? parseInt(updatedAccountInformation.financeDetail.finaceDetailId)
          : 0
      );
      setAccountType(updatedAccountInformation.accountType);

      if (
        Array.isArray(updatedAccountInformation.users) &&
        updatedAccountInformation.users.length > 0
      ) {
        setUserContacts(updatedAccountInformation.users);
      }

      if (
        Array.isArray(updatedAccountInformation.invoices) &&
        updatedAccountInformation.invoices.length > 0
      ) {
        setInvoices(updatedAccountInformation.invoices);
      }

      if (
        updatedAccountInformation.accountType == AccountType.MANAGED &&
        updatedAccountInformation.accountConfig
      ) {
        setManagedServicesConfig({
          agencyCommission:
            updatedAccountInformation.accountConfig.agencyCommission || "0",
          discount: updatedAccountInformation.accountConfig.discount || "0",
          enableAffiliateFlag:
            updatedAccountInformation.accountConfig.enableAffiliateFlag,
          viewableImpressionFlag:
            updatedAccountInformation.accountConfig.viewableImpressionFlag,
        });
      }

      if (
        updatedAccountInformation.accountType == AccountType.DIY &&
        updatedAccountInformation.accountConfig
      ) {
        setDIYConfig({
          creditLimit: updatedAccountInformation.accountConfig.creditLimit,
          agencyCommission:
            updatedAccountInformation.accountConfig.agencyCommission || "0",
          viewableImpressionFlag:
            updatedAccountInformation.accountConfig.viewableImpressionFlag,
          enableAffiliateFlag:
            updatedAccountInformation.accountConfig.enableAffiliateFlag,
        });
      }

      if (
        updatedAccountInformation.accountType == AccountType.DSP &&
        updatedAccountInformation.accountConfig
      ) {
        setDSPConfig({
          endPointURL:
            updatedAccountInformation.accountConfig.accountDspConfigDTO
              .endPointURL,
          defaultBidFloorPrize:
            updatedAccountInformation.accountConfig.accountDspConfigDTO
              .defaultBidFloorPrize,
          defaultNAds: updatedAccountInformation.accountConfig.defaultNAds,
          rtbVersion:
            updatedAccountInformation.accountConfig.accountDspConfigDTO
              .rtbVersion,
          viewableImpressionFlag:
            updatedAccountInformation.accountConfig.accountDspConfigDTO
              .viewableImpressionFlag,
        });
      }
    }
    if (fetchByAccountId) {
      fetchAccount();
    }
  }, [fetchByAccountId]);

  return (
    <AccountCreateContext.Provider
      value={{
        show,
        setShow,
        fetchBrandByAccountId,
        setFetchBrandByAccountId,
        managedServicesConfig,
        setManagedServicesConfig,
        DSPConfig,
        setDSPConfig,
        DIYConfig,
        setDIYConfig,
        userContacts,
        setUserContacts,
        invoices,
        setInvoices,
        accountID,
        setAccountID,
        dspconfigId,
        countryItem,
        setCountryItem,
        setEditContactId,
        configId,
        editContactId,
        financeId,
        setDspConfigId,
        setFinanceId,
        setConfigId,
        activeStep,
        setActiveStep,
        setIsEditing,
        isEditing,
        accountType,
        setAccountType,
        cdnBaseUrl,
        setCdnBaseUrl,
        accountViewRefresh,
        setAccountViewRefresh,
        primaryUserId,
        setPrimaryUserId,
        APIData,
        setAPIData,
        accountInformation,
        setAccountInformation,
        financialsIndia,
        setFinancialsIndia,
        gstnCopyFileImage,
        setGstnCopyFileImage,
        panCopyFileImage,
        setPanCopyFileImage,
        invoiceCopyFile,
        setInvoiceCopyFile,
        financialsNonIndia,
        setFinancialsNonIndia,
        breadCrumbName,
        setBreadCrumbName,
        popupMessage,
        setPopupMessage,
      }}
    >
      {children}
    </AccountCreateContext.Provider>
  );
};

export { AccountCreateContext, AccountCreateProvider };
